import { IconButton, SvgIcon, Tooltip } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { useAppTheme } from '@/theme/ThemeContext'

const BACK_TO_SITES_LABEL = 'חזרה לבחירת אתר'

// Router state sent with the navigation so SiteSelection knows the user chose
// to come back and must not auto-select a lone site again.
const FROM_SITE_BACK_STATE = { fromSiteBack: true } as const

// Chevron from Figma: 14x23, 2px round stroke, points right (= back in RTL).
const BackChevron = () => (
  <SvgIcon viewBox="0 0 14 23" sx={{ width: 14, height: 23 }}>
    <path
      d="M1 1L12.5 11.5L1 21.5"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
)

export default function BackToSitesButton() {
  const navigate = useNavigate()
  const { mode } = useAppTheme()
  const isDarkMode = mode === 'dark'

  return (
    <Tooltip title={BACK_TO_SITES_LABEL} placement="bottom">
      <IconButton
        aria-label={BACK_TO_SITES_LABEL}
        onClick={() => navigate('/sites', { state: FROM_SITE_BACK_STATE })}
        sx={{
          width: 40,
          height: 40,
          flexShrink: 0,
          borderRadius: 1.5,
          color: isDarkMode ? '#FFFFFF' : '#003F61',
          '&:hover': {
            backgroundColor: isDarkMode
              ? 'rgba(148,163,184,0.14)'
              : 'rgba(0, 0, 0, 0.04)',
          },
        }}
      >
        <BackChevron />
      </IconButton>
    </Tooltip>
  )
}
